import { Stack } from '@mui/material';
import { FC, useMemo } from 'react';

import {
  B2bPlanCategoryEsPeiValues,
  B2bSavingPlanCategoryCustomProduct,
} from '@Common/types/b2b/plans';
import { GetBoInvestorProfileIdEndpoint } from '@Common/types/bo/b2b/investor_profile';

import { B2bInvestorProfileGridOrdinatesColumn } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/components/B2bInvestorProfileGridOrdinatesColumn/B2bInvestorProfileGridOrdinatesColumn';
import {
  InvestorProfileGridSupportedPlanCategories,
  transformBoGridToFormGrid,
} from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/helpers/transformBoGridToFormGrid';
import { B2bInvestorProfileShowGridColumn } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileShowGridWrapper/components/B2bInvestorProfileShowGrid/components/B2bInvestorProfileShowGridColumn/B2bInvestorProfileShowGridColumn';

interface Props {
  allocation: GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['allocations'];
  productCategory: GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['plan_category'];
}

export const B2bInvestorProfileShowGrid: FC<Props> = (props) => {
  const { allocation, productCategory } = props;

  const convertedGrid = useMemo(
    () =>
      transformBoGridToFormGrid(
        allocation,
        productCategory as Extract<
          B2bSavingPlanCategoryCustomProduct,
          InvestorProfileGridSupportedPlanCategories
        >,
      ),
    [allocation, productCategory],
  );

  return (
    <Stack direction="row" spacing={3} overflow="scroll" paddingX={2}>
      {!B2bPlanCategoryEsPeiValues.some((category) => category === productCategory) && (
        <B2bInvestorProfileGridOrdinatesColumn currentGrid={convertedGrid} />
      )}
      {convertedGrid.map((column) => (
        <B2bInvestorProfileShowGridColumn key={column.instrument_id} allocation={column} />
      ))}
    </Stack>
  );
};
